const AbstractCloverRequestRecord = require('./AbstractCloverRequestRecord');
const CloverReceiptDeliveryMethod = require('@/lib/PaymentMethods/Clover/Enums/CloverReceiptDeliveryMethod');

class CloverReceiptRefundRequestRecord extends AbstractCloverRequestRecord {
    /**
     * @param {string} refundId // A uuid.
     * @param {} deliveryOption
     */
    constructor(refundId, deliveryOption) {
        if (!refundId || refundId.trim() === '') {
            throw new Error('refundId is required');
        }
        if (
            // @Todo test against actual DeliveryOption object.
            !deliveryOption
            || !deliveryOption.method
            || !CloverReceiptDeliveryMethod.hasOwnProperty(deliveryOption.method)
        ) {
            const methods = Object.values(CloverReceiptDeliveryMethod).join(', ');
            throw new Error('deliveryOption is required and must be one of ' + methods);
        }
        // @link https://docs.clover.com/reference/deliver_refund_receipt
        const url = '/connect/v1/refunds/' + refundId + '/receipt';
        super(
            'POST',
            url
        );
        this.data = {
            // printJobId,
            deliveryOption,
        };
    }
}

module.exports = CloverReceiptRefundRequestRecord;
